// extracted by mini-css-extract-plugin
module.exports = {"baseSectionMessage":"baseSectionMessage--OjJFb","message":"message--+B5md","button":"button--Cn-Hp"};